import React from "react";
import {
    Grid,
    Popper,
    TextField,
    Typography,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { isBacTempEmail, profileMatchesSearch } from "../utils";

const ViewportPopper = (props) => (
    <Popper
        {...props}
        popperOptions={{ positionFixed: true }}
        modifiers={{ preventOverflow: { enabled: true, boundariesElement: "viewport" } }}
    />
);

const label = (arb) => {
    if (!arb) return "";
    const email = arb?.user?.email;
    const showEmail = email && !isBacTempEmail(email);
    return `${arb?.user?.first_name || ''} ${arb?.user?.last_name || ''}${showEmail ? ` (${email})` : ''}`.trim();
};

// Each slot stores an arbitrator id, so the selected option is resolved by id and
// only the id is handed back on change — a cleared slot stays '' for the parent.
// Typing filters the list on name, email, phone or bar enrolment.
const ArbitratorPicker = ({ label: inputLabel, options, valueId, onSelect, required = false, error = '' }) => (
    <Autocomplete
        fullWidth
        PopperComponent={ViewportPopper}
        options={options}
        value={options.find((a) => Number(a.id) === Number(valueId)) || null}
        onChange={(event, option) => onSelect(option ? option.id : '')}
        getOptionLabel={label}
        getOptionSelected={(option, selected) => Number(option.id) === Number(selected?.id)}
        filterOptions={(opts, state) => opts.filter((o) => profileMatchesSearch(o, state.inputValue))}
        renderInput={(params) => (
            <TextField
                {...params}
                label={inputLabel}
                variant="outlined"
                required={required}
                error={!!error}
                helperText={error || ''}
            />
        )}
    />
);

const JudgePanelSelector = ({ arbitrators = [], value, onChange }) => {
    const { presiding, member1, member2 } = value;

    const getAvailable = (excludeIds) => {
        const excluded = excludeIds.filter(Boolean).map(Number);
        return arbitrators.filter((a) => !excluded.includes(Number(a.id)));
    };

    const handleSelect = (field) => (id) => {
        onChange({ ...value, [field]: id });
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography variant="subtitle2" style={{ marginBottom: 4 }}>
                    Arbitral Tribunal
                </Typography>
            </Grid>

            {/* Presiding/Sole Arbitrator — optional, like the other two */}
            <Grid item xs={12}>
                <ArbitratorPicker
                    label="Presiding/Sole Arbitrator"
                    options={getAvailable([member1, member2])}
                    valueId={presiding}
                    onSelect={handleSelect('presiding')}
                />
            </Grid>

            {/* Member 1 — optional */}
            <Grid item xs={12} sm={6}>
                <ArbitratorPicker
                    label="Co-Arbitrator"
                    options={getAvailable([presiding, member2])}
                    valueId={member1}
                    onSelect={handleSelect('member1')}
                />
            </Grid>

            {/* Member 2 — optional */}
            <Grid item xs={12} sm={6}>
                <ArbitratorPicker
                    label="Co-Arbitrator"
                    options={getAvailable([presiding, member1])}
                    valueId={member2}
                    onSelect={handleSelect('member2')}
                />
            </Grid>
        </Grid>
    );
};

export default JudgePanelSelector;
